/**
 * Common contracts shared between QB frontend and backend.
 */

export type Locale = 'en' | 'he' | 'pt' | 'ru';

export const SUPPORTED_LOCALES: readonly Locale[] = ['en', 'he', 'pt', 'ru'] as const;

export const RTL_LOCALES: readonly Locale[] = ['he'] as const;

export function isRtl(locale: Locale): boolean {
  return (RTL_LOCALES as readonly Locale[]).includes(locale);
}

/** Standard API success envelope. */
export interface ApiSuccess<T> {
  ok: true;
  data: T;
}

/** Standard API error envelope. */
export interface ApiError {
  ok: false;
  error: {
    code: string;
    message: string;
    details?: unknown;
  };
}

export type ApiResponse<T> = ApiSuccess<T> | ApiError;

/** Pagination request params. */
export interface PaginationParams {
  page?: number;
  pageSize?: number;
  search?: string;
  sortBy?: string;
  sortDir?: 'asc' | 'desc';
}

/** Pagination response wrapper. */
export interface Paginated<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
}

/** ISO-8601 datetime string. */
export type IsoDateTime = string;

/** UUID v4. */
export type UUID = string;
